import React from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

function MetricsAndAttributes() {
  return (
    <div className="w-full px-2 py-3 pb-24 overflow-y-auto">
      <div className="mx-6 my-2">
        <div className="font-bold text-2xl text-start">
          Reporting metrics & attributes
        </div>
        <p className="text-sm text-gray-700 pt-1 text-start">
          Reporting definitions to help you understand the datasets, metrics and
          attributes available in Intercom reports.
        </p>
        <div className="pt-5 flex items-center gap-3">
          <img
            className="w-10 h-10 border-2 border-white rounded-full"
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Elon_Musk_2015.jpg/408px-Elon_Musk_2015.jpg"
            alt=""
          />
          <div className="flex flex-col text-sm text-gray-700 text-start">
            <div>Written by Anish Dhakal</div>
            <div>Updated over a month ago</div>
          </div>
        </div>
        <div className="font-normal text-base mt-6">
          <button className="flex justify-between items-center w-full px-3 py-2 border rounded-lg shadow">
            <span>Table of contents</span>
            <ChevronDownIcon className="h-4 w-4" strokeWidth={2} />
          </button>
        </div>
        <div className="mt-6 text-start font-semibold text-2xl">
          Conversations dataset
        </div>
        <p className="mt-3 text-start text-sm">
          This dataset provides details at the conversation level, including the
          conversation ID, its current state, the communication channel used,
          and the assignee. It focuses on the overarching aspects of a
          conversation but does not cover individual conversation actions.
        </p>
      </div>
    </div>
  );
}

export default MetricsAndAttributes;
